import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Container, Row, Col } from 'react-bootstrap';

function AddressModal({ show, handleClose, handleSave, updateAddressId, handleUpdate }) {
  const isEditing = Boolean(updateAddressId);
  const [formData, setFormData] = useState({
    fullName: "",
    mobileNumber: "",
    address: "",
    addressLine_1: "",
    addressLine_2: "",
    addressType: "",
    city: "",
    state: "",
    postalCode: "",
    landmark: "",
    allowed_countries: [
      {
        name: "India",
        dialing_code: "+91",
        iso_code: "IN"
      }
    ],
    defaultAddress: false
  });

  const handleChange = (e) => {
    if (process.env.NODE_ENV === "development") {
      console.log(formData);
    }
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const onSave = () => {
    if (process.env.NODE_ENV === "development") {
      console.log("Saved Address Modal:", formData);
    }
    handleSave(formData);
    handleClose();
  };

  const handleSubmit = () => {
    if (isEditing) {
      // handleUpdate({ ...updateAddressId, ...formData });
      handleUpdate(formData);
    } else {
      handleSave(formData);
    }
    handleClose();
  };

  useEffect(() => {
    if (isEditing && updateAddressId) {
      setFormData({
        fullName: updateAddressId.fullName,
        mobileNumber: updateAddressId.mobileNumber,
        address: updateAddressId.address,
        addressLine_1: updateAddressId.addressLine_1,
        addressLine_2: updateAddressId.addressLine_2,
        addressType: updateAddressId.addressType,
        city: updateAddressId.city,
        state: updateAddressId.state,
        postalCode: updateAddressId.postalCode,
        landmark: updateAddressId.landmark,
        allowed_countries: [
          {
            name: "India",
            dialing_code: "+91",
            iso_code: "IN"
          }
        ],
        defaultAddress: updateAddressId.defaultAddress
      });
    } else {
      setFormData({
        fullName: "",
        mobileNumber: "",
        address: "",
        addressLine_1: "",
        addressLine_2: "",
        addressType: "",
        city: "",
        state: "",
        postalCode: "",
        landmark: "",
        allowed_countries: [
          {
            name: "India",
            dialing_code: "+91",
            iso_code: "IN"
          }
        ],
        defaultAddress: false
      });
    }
  }, [updateAddressId]);

  return (
    <Modal size="lg" show={show} onHide={handleClose} centered >
      <Modal.Header closeButton>
        <Modal.Title>{isEditing ? "Edit Address" : "Add New Address"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Form className="custom-form">
            <Row className="mb-3">
              <Col md={12}>
                <h5>Contact Details</h5>
                <hr />
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="fullName">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control type="text" name="fullName" value={formData.fullName} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="mobileNumber">
                  <Form.Label>Mobile</Form.Label>
                  <Form.Control type="text" name="mobileNumber" value={formData.mobileNumber} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col md={12}>
                <h5>Address Details</h5>
                <hr />
              </Col>
              <Col md={12}>
                <Form.Group className="mb-3" controlId="address">
                  <Form.Label>Address</Form.Label>
                  <Form.Control type="text" name="address" value={formData.address} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="addressLine_1">
                  <Form.Label>Address Line 1</Form.Label>
                  <Form.Control
                    type="text"
                    name="addressLine_1"
                    value={formData.addressLine_1}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="addressLine_2">
                  <Form.Label>Address Line 2</Form.Label>
                  <Form.Control
                    type="text"
                    name="addressLine_2"
                    value={formData.addressLine_2}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="landmark">
                  <Form.Label>Landmark</Form.Label>
                  <Form.Control
                    type="text"
                    name="landmark"
                    value={formData.landmark}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="mb-3" controlId="addressType">
                  <Form.Label>Address Type</Form.Label>
                  <div>
                    {['Home', 'Work', 'Other'].map((type) => (
                      <Form.Check
                        key={type}
                        inline
                        label={type}
                        type="radio"
                        name="addressType"
                        id={`addressType-${type}`}
                        value={type}
                        checked={formData.addressType === type}
                        onChange={handleChange}
                      />
                    ))}
                  </div>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3" controlId="city">
                  <Form.Label>City</Form.Label>
                  <Form.Control type="text" name="city" value={formData.city} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="state">
                  <Form.Label>State</Form.Label>
                  <Form.Control type="text" name="state" value={formData.state} onChange={handleChange} />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="postalCode">
                  <Form.Label>Postal Code</Form.Label>
                  <Form.Control type="text" name="postalCode" value={formData.postalCode} onChange={handleChange} />
                </Form.Group>
              </Col>
              {/* <Col lg={6}>
                <Form.Group className="mb-3" controlId="defaultAddress">
                  <Form.Label>Default Address</Form.Label>
                  <div>
                    {["Yes", "No"].map((type) => (
                      <Form.Check
                        key={type}
                        inline
                        label={type === "Yes" ? "Yes" : "No"}
                        type="radio"
                        name="defaultAddress"
                        id={`defaultAddress-${type}`}
                        value={type === "Yes" ? true : false}
                        checked={formData.defaultAddress === type}
                        onChange={handleChange}
                      />
                    ))}
                  </div>
                </Form.Group>
              </Col> */}

              <Col lg={6}>
                <Form.Group className="mb-3" controlId="defaultAddress">
                  <Form.Label>Default Type</Form.Label>
                  <div>
                    {['Yes', 'No'].map((type) => (
                      <Form.Check
                        key={type}
                        inline
                        label={type}
                        type="radio"
                        name="defaultAddress"
                        id={`defaultAddress-${type}`}
                        value={type}
                        checked={formData.defaultAddress === type}
                        onChange={handleChange}
                      />
                    ))}
                  </div>
                </Form.Group>
              </Col>


            </Row>
          </Form>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Cancel</Button>
        {/* <Button variant="primary" onClick={onSave}>Save Address</Button> */}
        <Button variant="primary" onClick={handleSubmit}>
          {isEditing ? "Update Address" : "Save Address"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddressModal;
